// src/constants/index.ts
var LANGUAGES = [
  { key: "en", name: "English" },
  { key: "es", name: "Spanish" }
];
var bucketTypeMap = {
  item: "items",
  combo: "combos",
  menuType: "menuTypes",
  menu: "menuTypes",
  category: "categories",
  subcategory: "subcategories",
  "modifier-item": "modifierItems",
  "gift-card": "general",
  "cash-drawer": "general",
  "id-scan": "general",
  customers: "general",
  "open-item": "general",
  fire: "general",
  "new-course": "general",
  "print-checks": "general"
};
var INITIAL_STATE_BASE_INTERFACE = {
  id: 0,
  createdAt: "",
  updatedAt: "",
  deletedAt: ""
};
var INITIAL_STATE_BASE_INTERFACE_WITH_STRING_ID = {
  id: "",
  createdAt: "",
  updatedAt: "",
  deletedAt: ""
};
var CallMethods = /* @__PURE__ */ ((CallMethods2) => {
  CallMethods2["Get"] = "get";
  CallMethods2["Post"] = "post";
  CallMethods2["Put"] = "put";
  CallMethods2["Delete"] = "delete";
  CallMethods2["Patch"] = "patch";
  CallMethods2["Stream"] = "stream";
  return CallMethods2;
})(CallMethods || {});
var statesList = /* @__PURE__ */ ((statesList2) => {
  statesList2["AL"] = "AL";
  statesList2["AR"] = "AR";
  statesList2["AS"] = "AS";
  statesList2["AZ"] = "AZ";
  statesList2["CA"] = "CA";
  statesList2["CO"] = "CO";
  statesList2["CT"] = "CT";
  statesList2["DC"] = "DC";
  statesList2["DE"] = "DE";
  statesList2["FL"] = "FL";
  statesList2["GA"] = "GA";
  statesList2["GU"] = "GU";
  statesList2["HI"] = "HI";
  statesList2["IA"] = "IA";
  statesList2["ID"] = "ID";
  statesList2["IL"] = "IL";
  statesList2["IN"] = "IN";
  statesList2["KS"] = "KS";
  statesList2["KY"] = "KY";
  statesList2["LA"] = "LA";
  statesList2["MA"] = "MA";
  statesList2["MD"] = "MD";
  statesList2["ME"] = "ME";
  statesList2["MI"] = "MI";
  statesList2["MN"] = "MN";
  statesList2["MO"] = "MO";
  statesList2["MS"] = "MS";
  statesList2["MT"] = "MT";
  statesList2["NC"] = "NC";
  statesList2["ND"] = "ND";
  statesList2["NE"] = "NE";
  statesList2["NH"] = "NH";
  statesList2["NJ"] = "NJ";
  statesList2["NM"] = "NM";
  statesList2["NV"] = "NV";
  statesList2["NY"] = "NY";
  statesList2["OH"] = "OH";
  statesList2["OK"] = "OK";
  statesList2["OR"] = "OR";
  statesList2["PA"] = "PA";
  statesList2["PR"] = "PR";
  statesList2["RI"] = "RI";
  statesList2["SC"] = "SC";
  statesList2["SD"] = "SD";
  statesList2["TN"] = "TN";
  statesList2["TX"] = "TX";
  statesList2["UT"] = "UT";
  statesList2["VA"] = "VA";
  statesList2["VI"] = "VI";
  statesList2["VT"] = "VT";
  statesList2["WA"] = "WA";
  statesList2["WI"] = "WI";
  statesList2["WV"] = "WV";
  statesList2["WY"] = "WY";
  return statesList2;
})(statesList || {});
var NULLISH_DATE = "0001-01-01T00:00:00Z";
var INITIAL_DURATION_OBJECT = {
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0
};
var CourseStates = /* @__PURE__ */ ((CourseStates2) => {
  CourseStates2["ACTIVE_ALERTED"] = "active alerted";
  CourseStates2["INACTIVE_COMPLETED"] = "inactive completed";
  CourseStates2["INACTIVE_ALERTED"] = "inactive alerted";
  CourseStates2["ACTIVE_COMPLETED"] = "active completed";
  return CourseStates2;
})(CourseStates || {});
var OrderFilter = /* @__PURE__ */ ((OrderFilter2) => {
  OrderFilter2["MULTISELECT"] = "multiselect";
  OrderFilter2["SELECT_ALL"] = "selectAll";
  OrderFilter2["NEW_ORDER"] = "newOrder";
  OrderFilter2["ALL_ORDERS"] = "allOrders";
  OrderFilter2["OPEN"] = "open";
  OrderFilter2["TIP_PENDING"] = "tip-pending";
  OrderFilter2["INCOMPLETE"] = "incomplete";
  OrderFilter2["FAILED"] = "failed";
  OrderFilter2["CLOSED"] = "closed";
  OrderFilter2["OTHER"] = "other";
  return OrderFilter2;
})(OrderFilter || {});
var OrderMainStatus = /* @__PURE__ */ ((OrderMainStatus3) => {
  OrderMainStatus3["OPEN"] = "open";
  OrderMainStatus3["TIP_PENDING"] = "tip-pending";
  OrderMainStatus3["CLOSED"] = "closed";
  OrderMainStatus3["FAILED"] = "failed";
  OrderMainStatus3["OTHER"] = "other";
  return OrderMainStatus3;
})(OrderMainStatus || {});
var OpenSubStatus = /* @__PURE__ */ ((OpenSubStatus3) => {
  OpenSubStatus3["INITIATED"] = "initiated";
  OpenSubStatus3["ORDERED"] = "ordered";
  return OpenSubStatus3;
})(OpenSubStatus || {});
var ClosedSubStatus = /* @__PURE__ */ ((ClosedSubStatus3) => {
  ClosedSubStatus3["BATCH_PENDING"] = "batchPending";
  ClosedSubStatus3["COMPLETE"] = "complete";
  return ClosedSubStatus3;
})(ClosedSubStatus || {});
var OtherSubStatus = /* @__PURE__ */ ((OtherSubStatus3) => {
  OtherSubStatus3["READY_FOR_PICKUP"] = "readyForPickup";
  OtherSubStatus3["ON_THE_WAY"] = "onTheWay";
  OtherSubStatus3["VOIDED"] = "voided";
  return OtherSubStatus3;
})(OtherSubStatus || {});
var ON_THE_FLY_NEW_COURSE_ID = 0;
var TAKE_OUT_ID = -1;
var DINE_IN_ID = -2;
var COMBOS_ID = -3;
var NEW_COURSE_ID = -4;
var ROUND_GROUPING_ID = -5;
var ON_HOLD_COURSE_ID = -6;
var DISABLED_COURSE_ID = -7;
var DINE_IN_PRIORITY = 0;
var TAKE_OUT_PRIORITY = 999999;
var COMBOS_PRIORITY = 999998;
var SIZE_MODIFIER_GROUP_ID = -1;
var INVISIBLE_CHAR = "\uFEFF";
var ORDER_TYPES = [
  "dine in" /* DINE_IN */,
  "to_go" /* TO_GO */,
  "delivery" /* DELIVERY */,
  "catering" /* CATERING */
];
var TSR_ORDER_TYPES = ["dine in" /* DINE_IN */, "to_go" /* TO_GO */];
var QSR_ORDER_TYPES = [
  ...TSR_ORDER_TYPES,
  "catering" /* CATERING */,
  "delivery" /* DELIVERY */
];
var PAYMENT_OPTIONS = [
  {
    optionId: "PAY" /* PAY */,
    paymentMethods: [
      "CASH" /* CASH */,
      "CREDIT_DEBIT" /* CREDIT_CARD */,
      "GIFT_CARD" /* GIFT_CARD */,
      "HOUSE" /* HOUSE */
      // EPaymentOptionMethod.MOBILE,
    ],
    defaultMethod: "CREDIT_DEBIT" /* CREDIT_CARD */
  },
  {
    optionId: "SPLIT" /* SPLIT */,
    paymentMethods: [
      "EVENLY" /* EVENLY */,
      "SEATS" /* SEATS */,
      "SELECT_ITEMS" /* SELECT_ITEMS */
    ],
    defaultMethod: "EVENLY" /* EVENLY */
  },
  {
    optionId: "PRE_AUTH" /* PRE_AUTH */,
    paymentMethods: ["CREDIT_DEBIT" /* CREDIT_CARD */],
    defaultMethod: "CREDIT_DEBIT" /* CREDIT_CARD */
  }
];
var ErrorCode = /* @__PURE__ */ ((ErrorCode2) => {
  ErrorCode2[ErrorCode2["OUTDATED_MENU"] = 5] = "OUTDATED_MENU";
  ErrorCode2[ErrorCode2["LICENSE_ALREADY_IN_USE"] = 10] = "LICENSE_ALREADY_IN_USE";
  ErrorCode2[ErrorCode2["OUTDATED_SETTINGS"] = 17] = "OUTDATED_SETTINGS";
  ErrorCode2[ErrorCode2["OUTDATED_MENU_AND_SETTINGS"] = 18] = "OUTDATED_MENU_AND_SETTINGS";
  ErrorCode2[ErrorCode2["LICENSE_MISSING"] = 60] = "LICENSE_MISSING";
  ErrorCode2[ErrorCode2["APP_VERSION_LOCK_OUT"] = 68] = "APP_VERSION_LOCK_OUT";
  ErrorCode2[ErrorCode2["TERMINAL_TRANSACTION_TIMEOUT"] = 76] = "TERMINAL_TRANSACTION_TIMEOUT";
  ErrorCode2[ErrorCode2["OUTDATED_REPORTS"] = 108] = "OUTDATED_REPORTS";
  ErrorCode2[ErrorCode2["CUSTOMER_PHONE_DUPLICATED"] = 111] = "CUSTOMER_PHONE_DUPLICATED";
  ErrorCode2[ErrorCode2["OUTDATED_CUSTOMER"] = 112] = "OUTDATED_CUSTOMER";
  ErrorCode2[ErrorCode2["OUTDATED_ORDER"] = 114] = "OUTDATED_ORDER";
  ErrorCode2[ErrorCode2["TABLE_OCCUPIED"] = 120] = "TABLE_OCCUPIED";
  return ErrorCode2;
})(ErrorCode || {});
var METRIC_UNITS_OF_LIQUID_VOLUME = [
  "pnt" /* PNT */,
  "qt" /* QT */,
  "gal" /* GAL */
];
var US_UNITS_OF_LIQUID_VOLUME = ["ml" /* ML */, "l" /* L */];
var ABSOLUTE_CERO = 1e-10;

// src/state/register/types.ts
var SET_TOGGLE_HOT_BUTTONS = "SET_TOGGLE_HOT_BUTTONS";
var SET_SHOW_HOT_BUTTONS = "SET_SHOW_HOT_BUTTONS";
var SET_REGISTER_NAVIGATION = "SET_REGISTER_NAVIGATION";
var UPDATE_REGISTER_NAVIGATION_FIELD = "UPDATE_REGISTER_NAVIGATION_FIELD";
var ADD_REMOVE_ACTIVE_ITEMS = "ADD_REMOVE_ACTIVE_ITEMS";
var CLEAN_NAVIGATION_AND_REMOVE_ACTIVE_ITEM = "CLEAN_NAVIGATION_AND_REMOVE_ACTIVE_ITEM";
var SET_ACTIVE_TICKET_ELEMENT = "SET_ACTIVE_TICKET_ELEMENT";
var SET_STATION_COUNTER = "SET_STATION_COUNTER";
var TOGGLE_ORDER_MODAL = "TOGGLE_ORDER_MODAL";
var SET_TICKET_ELEMENTS_OPEN = "SET_TICKET_ELEMENTS_OPEN";
var UPDATE_PAYMENT_NAVIGATION = "UPDATE_PAYMENT_NAVIGATION";
var ENTER_PAYMENT_MODE = "ENTER_PAYMENT_MODE";
var SET_PAYMENT_OPTION = "SET_PAYMENT_OPTION";
var SET_PAYMENT_METHOD = "SET_PAYMENT_METHOD";
var SET_SPECIALS_COUNTER = "SET_SPECIALS_COUNTER";
var ENABLE_EXIT_ORDER_CALL = "ENABLE_EXIT_ORDER_CALL";
var DISABLE_EXIT_ORDER_CALL = "DISABLE_EXIT_ORDER_CALL";
var EOrderModalMode = /* @__PURE__ */ ((EOrderModalMode2) => {
  EOrderModalMode2["CREATE"] = "CREATE";
  EOrderModalMode2["EDIT"] = "EDIT";
  return EOrderModalMode2;
})(EOrderModalMode || {});
var EPaymentOption = /* @__PURE__ */ ((EPaymentOption2) => {
  EPaymentOption2["PAY"] = "PAY";
  EPaymentOption2["SPLIT"] = "SPLIT";
  EPaymentOption2["PRE_AUTH"] = "PRE_AUTH";
  EPaymentOption2["NULL"] = "";
  return EPaymentOption2;
})(EPaymentOption || {});
var EPaymentOptionMethod = /* @__PURE__ */ ((EPaymentOptionMethod2) => {
  EPaymentOptionMethod2["CASH"] = "CASH";
  EPaymentOptionMethod2["CREDIT_CARD"] = "CREDIT_DEBIT";
  EPaymentOptionMethod2["GIFT_CARD"] = "GIFT_CARD";
  EPaymentOptionMethod2["HOUSE"] = "HOUSE";
  EPaymentOptionMethod2["MOBILE"] = "MOBILE";
  EPaymentOptionMethod2["EVENLY"] = "EVENLY";
  EPaymentOptionMethod2["SEATS"] = "SEATS";
  EPaymentOptionMethod2["SELECT_ITEMS"] = "SELECT_ITEMS";
  EPaymentOptionMethod2["NULL"] = "";
  return EPaymentOptionMethod2;
})(EPaymentOptionMethod || {});
var ESendGroup = /* @__PURE__ */ ((ESendGroup2) => {
  ESendGroup2["ITEMS"] = "ITEMS";
  ESendGroup2["COURSE"] = "COURSE";
  ESendGroup2["NONE"] = "NONE";
  return ESendGroup2;
})(ESendGroup || {});
var ESplitTypes = /* @__PURE__ */ ((ESplitTypes2) => {
  ESplitTypes2["SHARED"] = "SHARED";
  ESplitTypes2["SPLIT"] = "SPLIT";
  return ESplitTypes2;
})(ESplitTypes || {});
var ALL_SEATS = 0;
var NO_SEAT_ID = -2;
var FOR_TABLE_SEAT_ID = -1;
var TO_GO_SEAT_ID = -3;
var SHARED_SEAT_ID = -4;
var VAO_DATA_INITIAL_STATE = {
  isMultiselect: false,
  selectedOrders: [],
  isVAOFocused: false,
  filter: "open" /* OPEN */,
  selectedCheckId: null
};
var EPaymentNavigationScreens = /* @__PURE__ */ ((EPaymentNavigationScreens2) => {
  EPaymentNavigationScreens2["PAYMENT"] = "PAYMENT";
  EPaymentNavigationScreens2["CHECK_EDITOR"] = "CHECK_EDITOR";
  return EPaymentNavigationScreens2;
})(EPaymentNavigationScreens || {});
var ECheckDefaultSplitTypes = /* @__PURE__ */ ((ECheckDefaultSplitTypes2) => {
  ECheckDefaultSplitTypes2["EVENLY"] = "EVENLY";
  ECheckDefaultSplitTypes2["SEATS"] = "SEATS";
  ECheckDefaultSplitTypes2["CUSTOM"] = "CUSTOM";
  ECheckDefaultSplitTypes2["NONE"] = "";
  return ECheckDefaultSplitTypes2;
})(ECheckDefaultSplitTypes || {});
var DrawerActions = /* @__PURE__ */ ((DrawerActions2) => {
  DrawerActions2["REFUND"] = "refund";
  DrawerActions2["WITHDRAW"] = "withdraw";
  DrawerActions2["CASH_IN"] = "cash in";
  DrawerActions2["CASH_OUT"] = "cash out";
  DrawerActions2["NO_SALE"] = "no sale";
  DrawerActions2["SALE"] = "sale";
  DrawerActions2["PRINT_BALANCE"] = "print balance";
  DrawerActions2["ADJUST_BALANCE"] = "adjust balance";
  DrawerActions2["CLOSE_DRAWER"] = "close drawer";
  DrawerActions2["OPEN_DRAWER"] = "open drawer";
  DrawerActions2["EDIT_DRAWER"] = "edit drawer";
  DrawerActions2["CREATE_DRAWER"] = "create drawer";
  DrawerActions2["CLONE"] = "clone";
  DrawerActions2["STATUS_CHANGE"] = "status change";
  DrawerActions2["COUNT"] = "count";
  DrawerActions2["CLOSE"] = "close";
  DrawerActions2["OPEN"] = "open";
  DrawerActions2["CONFIRM_STARTING_BALANCE"] = "confirm starting balance";
  DrawerActions2["SETTLE_AND_CLOSE"] = "settle and close";
  DrawerActions2["CLOCKED_OUT"] = "clocked out";
  DrawerActions2["TIPS_DUE"] = "tips due";
  DrawerActions2["TIPS_REFUNDED"] = "tips refunded";
  DrawerActions2["SETTLE"] = "settle";
  return DrawerActions2;
})(DrawerActions || {});
var CASH_IN_ACTIONS = /* @__PURE__ */ ((CASH_IN_ACTIONS2) => {
  CASH_IN_ACTIONS2["SERVER_DRAWER"] = "server drawer";
  CASH_IN_ACTIONS2["DEPOSIT"] = "deposit";
  CASH_IN_ACTIONS2["TIP_OUT"] = "tip out";
  return CASH_IN_ACTIONS2;
})(CASH_IN_ACTIONS || {});
var CASH_OUT_ACTIONS = /* @__PURE__ */ ((CASH_OUT_ACTIONS2) => {
  CASH_OUT_ACTIONS2["SERVER_DRAWER"] = "server drawer";
  CASH_OUT_ACTIONS2["PAY_OUT"] = "pay out";
  CASH_OUT_ACTIONS2["CASH_DROP"] = "cash drop";
  return CASH_OUT_ACTIONS2;
})(CASH_OUT_ACTIONS || {});
var EPrintError = /* @__PURE__ */ ((EPrintError2) => {
  EPrintError2["PRINT_JOB_EXECUTION"] = "Print Job Execution";
  EPrintError2["PRINT_JOB_CREATION"] = "Print Job Creation";
  return EPrintError2;
})(EPrintError || {});
var EErrorCode = /* @__PURE__ */ ((EErrorCode2) => {
  EErrorCode2["INTERNAL"] = "INTERNAL";
  EErrorCode2["NO_SETTINGS"] = "NO_SETTINGS";
  EErrorCode2["NO_PREP_STATION"] = "NO_PREP_STATION";
  EErrorCode2["NO_PRINTER"] = "NO_PRINTER";
  EErrorCode2["PREP_STATION_INACTIVE"] = "PREP_STATION_INACTIVE";
  EErrorCode2["NOT_CONFIRMED"] = "NOT_CONFIRMED";
  EErrorCode2["PRINTER_ERROR"] = "PRINTER_ERROR";
  return EErrorCode2;
})(EErrorCode || {});

export { ABSOLUTE_CERO, ADD_REMOVE_ACTIVE_ITEMS, ALL_SEATS, CASH_IN_ACTIONS, CASH_OUT_ACTIONS, CLEAN_NAVIGATION_AND_REMOVE_ACTIVE_ITEM, COMBOS_ID, COMBOS_PRIORITY, CallMethods, ClosedSubStatus, CourseStates, DINE_IN_ID, DINE_IN_PRIORITY, DISABLED_COURSE_ID, DISABLE_EXIT_ORDER_CALL, DrawerActions, ECheckDefaultSplitTypes, EErrorCode, ENABLE_EXIT_ORDER_CALL, ENTER_PAYMENT_MODE, EOrderModalMode, EPaymentNavigationScreens, EPaymentOption, EPaymentOptionMethod, EPrintError, ESendGroup, ESplitTypes, ErrorCode, FOR_TABLE_SEAT_ID, INITIAL_DURATION_OBJECT, INITIAL_STATE_BASE_INTERFACE, INITIAL_STATE_BASE_INTERFACE_WITH_STRING_ID, INVISIBLE_CHAR, LANGUAGES, METRIC_UNITS_OF_LIQUID_VOLUME, NEW_COURSE_ID, NO_SEAT_ID, NULLISH_DATE, ON_HOLD_COURSE_ID, ON_THE_FLY_NEW_COURSE_ID, ORDER_TYPES, OpenSubStatus, OrderFilter, OrderMainStatus, OtherSubStatus, PAYMENT_OPTIONS, QSR_ORDER_TYPES, ROUND_GROUPING_ID, SET_ACTIVE_TICKET_ELEMENT, SET_PAYMENT_METHOD, SET_PAYMENT_OPTION, SET_REGISTER_NAVIGATION, SET_SHOW_HOT_BUTTONS, SET_SPECIALS_COUNTER, SET_STATION_COUNTER, SET_TICKET_ELEMENTS_OPEN, SET_TOGGLE_HOT_BUTTONS, SHARED_SEAT_ID, SIZE_MODIFIER_GROUP_ID, TAKE_OUT_ID, TAKE_OUT_PRIORITY, TOGGLE_ORDER_MODAL, TO_GO_SEAT_ID, TSR_ORDER_TYPES, UPDATE_PAYMENT_NAVIGATION, UPDATE_REGISTER_NAVIGATION_FIELD, US_UNITS_OF_LIQUID_VOLUME, VAO_DATA_INITIAL_STATE, bucketTypeMap, statesList };
